/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable hydrogen/prefer-image-component */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react/no-unknown-property */
/* eslint-disable no-unused-vars */
// import {Image, Link, Video} from '@shopify/hydrogen';
// import {useState, useRef, useEffect} from 'react';
import {Image, Link} from '@shopify/hydrogen';
import {Button, Text} from '~/components/elements';
import {Section} from '~/components/elements';

import clsx from 'clsx';

import {missingClass} from '~/lib/utils';
export function Banner({
  className,
  variant = 'primary',
  type = 'mainBanner',
  padding = 'y',
  ...props
}) {
  const BaseStyles =
    'group relative grid w-full grid-cols-1 place-items-center overflow-hidden';

  const types = {
    mainBanner: `px-6 py-4 lg:p-7 xl:py-[55px] sm:grid-cols-3 sm:place-items-start lg:px-20 xl:px-34`,
    saleBanner: `sm:px-6 lg:px-40 xl:px-34 p-4 md:py-4.5 lg:py-6 xl:py-8
                 [&>div]:py-3.5 [&>div]:bg-black/30 [&>div]:md:py-6 [&>div]:lg:py-10 [&>div]:xl:py-12`,
  };
  // const types = {
  //   mainBanner: ``,
  //   saleBanner: `
  //                [&>div]:py-3.5 [&>div]:bg-black/70 [&>div]:md:py-6 [&>div]:lg:py-10 [&>div]:xl:py-12`,
  // };
  const image = props?.banner_image?.reference?.image
    ? props.banner_image.reference.image
    : props.image;
  const styles = clsx(BaseStyles, types[type], className);
  return (
    <Section padding={padding} className={styles}>
      {props?.clickable?.value === 'true' && (
        <Link
          className="absolute inset-0 z-10 cursor-pointer"
          to={`/collections/${props.handle}`}
        ></Link>
      )}
      {image && (
        <Image
          alt={image.altText || props.title}
          className="absolute -z-10 min-h-full min-w-full object-cover object-center"
          // object-none object-center
          data={image}
          loaderOptions={{
            scale: 2,
            crop: 'center',
          }}
        />
      )}
      {(props.cta || props.heading || props.byline) && (
        <div className={` w-full`}>
          <div className="grid justify-center gap-1 md:gap-3 lg:gap-4 xl:gap-5">
            {props?.heading?.value && (
              <Text
                as="div"
                size="title"
                className="min-w-max text-center font-extrabold text-white"
              >
                {props.heading.value}
              </Text>
            )}
            {props?.byline?.value && (
              <Text
                as="div"
                size="productCardHeader"
                className="max-w-xs text-center text-xs text-white sm:max-w-sm lg:max-w-md"
              >
                {props.byline.value}
              </Text>
            )}
            {props?.clickable?.value && (
              <Text
                as="div"
                size="productCardPrice"
                className="text-center font-normal text-white underline"
              >
                {props.cta.value}
              </Text>
            )}
          </div>
          {props?.clickable?.value === 'true' && (
            <div className="group-hover:animate-shine absolute -inset-full top-0 block h-full w-1/2 -skew-x-12 transform bg-gradient-to-r from-transparent to-white opacity-40" />
          )}
        </div>
      )}
    </Section>
  );
}
